import 'utils/eventPolyfill'

import React from 'react'
import ReactDOM from 'react-dom'

// Ran into issues having this before the react imports
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

import { BrowserRouter } from 'react-router-dom'
import {
  applyPolyfills,
  defineCustomElements,
} from '@workbench/core/dist/loader'

import './i18n.ts'
import { App } from './App'
import { AuthProvider } from 'hooks/useAuthentication'
import { FeatureFlagsProvider } from 'hooks/useFeatureFlags'
import './index.scss'
import './workbench.d.ts'

const render = (Component: any) => {
  return ReactDOM.render(
    <React.StrictMode>
      <FeatureFlagsProvider>
        <BrowserRouter>
          <AuthProvider>
            <Component />
          </AuthProvider>
        </BrowserRouter>
      </FeatureFlagsProvider>
    </React.StrictMode>,
    document.getElementById('root')
  )
}

render(App)

if ((module as any).hot) {
  ;(module as any).hot.accept('./App', () => {
    const NextApp = require('./App').App
    render(NextApp)
  })
}

applyPolyfills().then(() => {
  defineCustomElements(window)
})
